<template>
  <div class="container  m-t-lg p-b-lg">
    <div class="columns">

      <div class="column is-6 is-offset-one-quarter jpo-form box">
        <div class="school-border" :style="'border-top: 5px solid '+schoolColor"></div>

        <a class="button has-text-weight-normal m-md"
           @click="goBack" v-if="isLoggedIn">
                    <span class="icon is-large">
                      <i class="fa fa-angle-left fa-2x"></i>
                    </span>
          <span>Retour à la candidature</span>
        </a>

        <div class="has-text-centered">
          <img :src="'/img/logos/'+ slug +'.png'" class="school-logo" alt="">
        </div>

        <form @submit.prevent="send" v-if="!userRegistered">
          <div class="card-content">
            <div class="content">
              <div class="title is-4 has-text-centered has-text-weight-light heading-line">
                <span>{{ $t('contact.jpo_doc.title') }}</span>
              </div>
              <div v-if="!isLoggedIn">
                <div class="field">
                  <div class="field-body">
                    <div class="field">
                      <p class="control">
                        <label class="label">{{ $t('candidate.contact.last_name') }}</label>
                        <b-field>
                          <b-input v-model="account.last_name"
                                   minlength="1"
                                   custom-class="jpo-label"
                                   size="is-medium"
                                   required>

                          </b-input>
                        </b-field>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="field">
                  <div class="field-body">
                    <div class="field">
                      <p class="control">
                        <label class="label">{{ $t('candidate.contact.first_name') }}</label>
                        <b-field>
                          <b-input v-model="account.first_name"
                                   minlength="1"
                                   size="is-medium"
                                   required>

                          </b-input>
                        </b-field>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="field">
                  <div class="field-body">
                    <div class="field">
                      <p class="control">
                        <label class="label">{{ $t('connection.email') }}</label>
                        <b-field>
                          <b-input type="email"
                                   size="is-medium"
                                   v-model="account.email"
                                   required>
                          </b-input>
                        </b-field>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="field">
                  <div class="field-body">
                    <div class="field">
                      <div class="control">
                        <div class="columns">
                          <div class="column">
                            <label class="label" v-bind:class="[ errors.has('phone') ? 'has-text-danger' : '']">
                              Téléphone</label>

                            <VuePhoneNumberInput v-model="account.phone"
                                                 :required="true"
                                                 :border-radius="0"
                                                 color="firebrick"
                                                 :preferred-countries="['FR']"
                                                 @update="updateCandidatePhone"
                                                 :translations="{
                                                            countrySelectorLabel: 'Code pays',
                                                            countrySelectorError: 'Choisir un pays',
                                                            phoneNumberLabel: 'Numéro de téléphone',
                                                            example: 'Exemple :'
                                                          }"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="field">
                  <p class="control is-expanded">
                    <label class="label">{{ $t('candidate.contact.nationality') }}</label>
                    <b-field class="has-text-left">
                      <b-select
                          v-model="account.nationality"
                          required
                          @input="onNationalityChange"
                      >
                        <option value="">---</option>

                        <option
                            v-for="country in countries"
                            :value="country['alpha-2']"
                        >
                          {{ country.nationality }}
                        </option>
                      </b-select>
                    </b-field>
                  </p>
                </div>
                <hr>
              </div>


              <div class="field m-t-lg">
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <label class="label">{{ $t('contact.jpo_doc.event_choice') }}</label>
                      <div class="columns">
                        <div class="column">
                          <a @click="toggleCampuses"
                             class="box">
                                                        <span class="m-r-md title is-4" v-if="account.campus">
                                                                <strong>{{ account.campus.name }}</strong>
                                                            </span>
                            <span v-else class="m-r-md has-text-grey-light"
                                  :class="[ errors.has('training') ? 'has-text-danger' : '']">{{
                                $t('contact.jpo_doc.event_select_choice')
                              }}</span>
                            <i :class="campusList ?'fa fa-angle-up':'fa fa-angle-down'"/>
                          </a>
                          <span v-show="errors.has('event')" class="help is-danger">{{ errors.first('event') }}</span>
                        </div>
                      </div>

                      <transition name="slide-fade">
                        <div v-show="campusList" v-if="school">
                          <div class="m-sm" v-for="campus in school.campuses">
                            <a class="box" @click="campusChoice(campus)">
                              <div class="option__title m-b-sm title is-4 has-text-centered"><i>{{ campus.name }}</i>
                              </div>
                            </a>
                          </div>
                        </div>
                      </transition>
                    </div>
                  </div>
                </div>
              </div>

              <div class="field m-t-lg" v-if="!isLoggedIn">
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <label class="label">{{ $t('contact.jpo_doc.training') }}</label>
                      <div class="columns">
                        <div class="column">
                          <a @click="toggleTrainings"
                             class="box" :class="[!account.nationality ? 'disabled-training-choice':'']">
                                                        <span class="m-r-md" v-if="account.training">
                                                            <strong>{{ account.training.name }}</strong>
                                                        </span>
                            <span v-else class="m-r-md has-text-grey-light"
                                  :class="[ errors.has('training') ? 'has-text-danger' : '']">{{
                                $t('contact.jpo_doc.training_choice')
                              }}</span>
                            <i :class="trainingList ?'fa fa-angle-up':'fa fa-angle-down'"/>
                          </a>
                          <span v-show="errors.has('training')" class="help is-danger">{{
                              errors.first('training')
                            }}</span>
                        </div>
                      </div>
                      <div class="columns ">
                        <div class="column ">
                          <transition name="slide-fade">
                            <div v-show="trainingList" class="m-sm has-text-centered">
                              <div class="tile is-ancestor">
                                <div class="tile is-vertical is-parent" v-for="column in chunkedThemes">

                                  <div class="tile is-child" v-for="theme in column">
                                    <h3 class="title is-3 heading-line has-text-weight-light"
                                        v-if="theme.name !== 'notheme' && theme.trainings.length"><span
                                        :style="'color: '+school.school_color">{{ theme.name }}</span></h3>
                                    <div v-for="training in theme.trainings" :key="training.id"
                                         class="has-text-centered training-link m-b-sm">
                                      <a class="box training-name"
                                         @click="trainingChoice(training)">
                                        <img style="width: 11rem;float: left;" v-if="school.slug !== training.school.slug" :src="'/img/logos/'+ training.school.slug+'.png'" class="school-logo" alt="">
                                        <span class="title is-4 has-text-weight-light">
                                          {{ training.name }}
                                          <html-tooltip
                                              v-if="training && training.presentation"
                                              :content="training.presentation"
                                              position="is-bottom" class="is-multiline p-l-sm" :style="'color: '+training.school.school_color"/>

                                          <hr>
                                          <span v-for="option in training.options" class="title is-5 has-text-weight-light is-italic p-sm">
                                            {{ option.name }}
                                          </span>
                                        </span>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </transition>
                          <transition name="slide-fade" v-if="account.training && school.type === 'boardingschool'">
                            <div>
                              <label class="label">{{ $t('contact.jpo_doc.internship') }}</label>
                              <div class="">
                                <a class="button m-sm"
                                   :class="[account.internship_choice === 'externship_full' ? 'selected-section':'']"
                                   @click="account.internship_choice = 'externship_full'">{{
                                    $t('candidate.choices.boardingschool.externship_full')
                                  }}
                                </a>
                                <a class="button m-sm"
                                   :class="[account.internship_choice === 'externship' ? 'selected-section':'']"
                                   @click="account.internship_choice = 'externship'">{{
                                    $t('candidate.choices.boardingschool.externship')
                                  }}
                                </a>

                                <a class="button m-sm"
                                   :class="[account.internship_choice === 'internship' ? 'selected-section':'']"
                                   @click="account.internship_choice = 'internship'">{{
                                    $t('candidate.choices.boardingschool.internship')
                                  }}
                                </a>
                                <a class="button m-sm"
                                   :class="[account.internship_choice === 'internship_7' ? 'selected-section':'']"
                                   @click="account.internship_choice = 'internship_7'">{{
                                    $t('candidate.choices.boardingschool.internship_7')
                                  }}
                                </a>
                                <a class="button m-sm"
                                   :class="[account.internship_choice === 'internship_full' ? 'selected-section':'']"
                                   @click="account.internship_choice = 'internship_full'">{{
                                    $t('candidate.choices.boardingschool.internship_full')
                                  }}
                                </a>
                                <span v-show="errors.has('trainingInternship')"
                                      class="help is-danger">{{ errors.first('trainingInternship') }}</span>
                              </div>
                            </div>
                          </transition>
                          <div v-if="!isBoardingSchool">
                            <transition name="slide-fade" v-if="account.training">
                              <div class="columns">
                                <div class="column has-text-left" v-if="trainingOptions.length > 0">
                                  <div>
                                    <label class="label is-size-5">Option/Année</label>
                                    <span v-for="option in trainingOptions" :key="option.id"
                                          class="has-text-left training-options">
                                            <a class="button m-r-sm m-b-sm"

                                               :class="[selectedOption === option.id ? 'selected-option':'']"
                                               @click="optionChoice(option)">{{
                                                option.name
                                              }}</a>
                                        </span>
                                    <span v-show="errors.has('trainingOption')"
                                          class="help is-danger">{{ errors.first('trainingOption') }}</span>
                                  </div>
                                </div>

                              </div>
                            </transition>
                            <transition name="slide-fade" v-if="account.training">
                              <div class="columns" v-if="optionPaces.length > 0">
                                <div class="column">
                                  <div>
                                    <label class="label is-size-5">Rythme</label>
                                    <PaceButton :optionPaces="optionPaces"
                                                :europeanNationality="europeanNationality"
                                                :selectedPace="selectedPace"
                                                @pace-chosen="paceChoice" />
                                  </div>
                                </div>
                              </div>
                            </transition>
                          </div>
                          <div v-else>
                            <transition name="slide-fade" v-if="account.training">
                              <div class="columns">
                                <div class="column" v-if="trainingOptions.length > 0 && account.training_campus">
                                  <div>
                                    <label class="label is-size-5">Option/Année</label>
                                    <span v-for="option in trainingOptions" :key="option.id"
                                          class="has-text-left training-options">
                                            <a class="button m-r-sm m-b-sm"
                                               v-if="getCampusBySlug(account.training_campus).id === option.campus_id"
                                               :class="[selectedOption === option.id ? 'selected-option':'']"
                                               @click="optionChoice(option)">{{
                                                option.name
                                              }}</a>
                                        </span>
                                    <span v-show="errors.has('trainingOption')"
                                          class="help is-danger">{{ errors.first('trainingOption') }}</span>
                                  </div>
                                </div>

                              </div>
                            </transition>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="has-text-centered">
            <div class="title is-5 has-text-weight-light" v-if="school"><i>{{ $t('contact.jpo_doc.contact_phone') }}
              {{ school.phone }}</i></div>
          </div>


          <hr>
          <div class="has-text-centered">
            <button :class="'is-large button-valid button ' + isLoading">
              {{ $t('contact.jpo_doc.send') }}
            </button>
            <br>
            <br>
            <transition name="slide-fade">
              <div class="has-text-danger has-text-centered p-b-md">{{ errorMsg }}</div>
            </transition>
          </div>

        </form>

        <transition name="component-fade" mode="out-in">
          <div class="section has-text-centered" v-if="userRegistered && account.campus">
            <div class="title is-4 has-text-weight-light has-text-success heading-line p-b-md">
              <span>{{ $t('contact.jpo_doc.registered.title') }}</span>
            </div>
            <div class="subtitle has-text-weight-light is-3">
              Vous allez recevoir un email confirmant votre inscription.<br>
              Ainsi que vos identifiants afin de vous connecter
              à votre espace personnel<br> <strong>Diderot Max</strong>.<br>
              <u><i>Pensez à vérifiez dans vos SPAMS.</i></u>

              <hr>
              <div>
                <div class="is-italic p-t-md p-b-sm is-size-3">
                  Rejoignez-nous sur:
                </div>
                <a v-if="school.instagram" target="_blank" :href="school.instagram" class="p-r-md">
                  <i class="fa fa-instagram fa-2x"/> </a>
                <a v-if="school.facebook" target="_blank" :href="school.facebook" class="p-r-md">
                  <i class="fa fa-facebook fa-2x"/> </a>
                <a v-if="school.youtube" target="_blank" :href="school.youtube" class="p-r-md">
                  <i class="fa fa-youtube fa-2x"/> </a>
              </div>

            </div>
          </div>
        </transition>
        <transition name="component-fade" mode="out-in">
          <div class="section has-text-centered" v-if="existingEmail">
            <div class="title is-4 has-text-weight-bold has-text-warning heading-line p-b-md">
              <span>{{ $t('contact.registered.exist') }}</span>
            </div>
            <div class="subtitle">
              {{ $t('contact.registered.connect') }}
            </div>
            <button class="is-large button-valid button" @click="login()">
              {{ $t('contact.registered.to_login') }}
            </button>
          </div>
        </transition>
      </div>
    </div>

  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Cleave from '../../../../../node_modules/cleave.js/dist/cleave'
import CountriesFR from '../../utils/countries_fr.json'
import api from 'services/organization'
import services from 'services/account'
import apiCandidate from 'services/candidate'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import CountriesEU from "../../utils/euro-countries.json";
import _ from "lodash";
import htmlTooltip from "../elements/html-tooltip.vue";
import PaceButton from "../application/PaceButton.vue";

const cleave = {
  name: 'cleave',
  bind(el, binding) {
    const input = el.querySelector('input')
    input._vCleave = new Cleave(input, binding.value)
  },
  update(el, binding) {
    const input = el.querySelector('input')
    input._vCleave.destroy()
    input._vCleave = new Cleave(input, binding.value)
  },
  unbind(el) {
    const input = el.querySelector('input')
    input._vCleave.destroy()
  }
}

export default {
  directives: {cleave},
  components: {
    PaceButton,
    VuePhoneNumberInput,
    htmlTooltip
  },
  data() {
    return {
      errorMsg: '',
      isLoading: '',
      schoolColor: '',
      trainingList: false,
      trainingOptions: [],
      optionPaces: [],
      selectedPace: null,
      selectedOption: null,
      campusList: false,
      trainings: [],
      events: [],
      userRegistered: false,
      existingEmail: false,
      account: {
        gender: '',
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        phone_code: '',
        nationality: '',
        training: null,
        training_campus: null,
        training_option_id: null,
        training_option_name: null,
        internship_choice: null,
        event: null,
        campus: null,
        source: this.source,
        utm_source: this.utm_source,
        utm_medium: this.utm_medium,
        utm_campaign: this.utm_campaign,
        utm_term: this.utm_term,
        utm_content: this.utm_content,
      },
      countries: CountriesFR,
      countriesEU: CountriesEU,
      error: '',
    }
  },
  props: {
    source: { type: String, default: null },
    utm_source: { type: String, default: null },
    utm_medium: { type: String, default: null },
    utm_campaign: { type: String, default: null },
    utm_term: { type: String, default: null },
    utm_content: { type: String, default: null },
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn',
      userAccount: 'auth/getAccount',
      candidate: 'candidate/getSingleCandidate',
      schoolBySlug: 'organization/getSchoolBySlug',
      campusById: 'organization/campusById',
      campusBySlug: 'organization/campusBySlug',
    }),
    school() {
      return this.schoolBySlug(this.$route.params.school)
    },
    slug() {
      if (this.$route.params.campus) {
        return this.$route.params.campus
      } else {
        return this.$route.params.school
      }
    },
    europeanNationality() {
      return !this.account.nationality || Boolean(_.find(this.countriesEU, {code: this.account.nationality}));
    },
    isBoardingSchool () {
      return this.school && this.school.type === 'boardingschool'
    },
    isESchool () {
      return this.school && this.school.type === 'eschool'
    },
    chunkedThemes() {

      let trainings = this.trainings
      if (!this.europeanNationality) {
        trainings = trainings.map((element) => {
          return {...element, trainings: element.trainings.filter((t) => t.foreign_access === true)}
        })
      }

      const result = []

      // default size to two item
      let size = 10


      // add each chunk to the result
      for (let x = 0; x < Math.ceil(trainings.length / size); x++) {
        const start = x * size
        const end = start + size

        result.push(trainings.slice(start, end))
      }
      return result
    },
  },
  methods: {
    ...mapActions({
      refreshAccount: 'auth/setAccount',
      jpoEvent: 'candidate/addJpoEvent',
      fetchSchools: 'organization/fetchSchools',
      fetchCampuses: 'organization/fetchCampuses'
    }),
    getCampus(id) {
      const campus = this.campusById(id)
      if (campus) {
        return campus.name
      }
    },
    goBack() {
      if (
          this.$route.params.school === "france" ||
          this.$route.params.school === "suisse"
      ) {

        this.$router.replace({
          path:
              "/admissionsco/" + this.$route.params.school + "/mon-compte"
        });

      } else {
        this.$router.replace({
          path: "/admissionsup/" + this.$route.params.school + "/mon-compte"
        });
      }
    },
    getCampusBySlug (slug) {
      return this.campusBySlug(slug)
    },
    formatDate(date) {
      return moment(date).format('dddd LL');
    },
    dateHour(date) {
      return moment(date).format('HH:mm');
    },
    eventLabel(event) {
      if (event.category.slug === 'rencontre' && event.display_urls) {
        return `Rencontre en ligne – ${this.eventDate(event)}`
      } else {
        return `${event.city} – ${this.eventDate(event)} – ${event.address}`
      }
    },
    eventDate(event) {
      if (event.end_set) {
        return moment(event.start).format('dddd LL') + ' de ' + moment(event.start).format('HH:mm') + ' à ' + moment(event.end).format('HH:mm')
      } else {
        return moment(event.start).format('dddd LL') + ' à ' + moment(event.start).format('HH:mm')
      }

    },
    toggleTrainings() {
      this.trainingList = !this.trainingList
    },
    toggleCampuses() {
      this.campusList = !this.campusList
    },
    toggleLoading: function () {
      this.isLoading = (this.isLoading === '') ? 'is-loading' : ''
    },

    fetchSchoolTrainings: function () {
      if (this.$route.params.school) {
        api.schoolTrainings(this.$route.params.school).then((result) => {
          this.trainings = result.data
        }).catch(e => {
        })
      }
      api.campuses().then((result) => {
        this.campuses = result.data
      }).catch(e => {
      })
    },
    fetchSchoolEvents: function () {
      if (this.$route.params.school) {
        api.schoolEvents(this.$route.params.school).then((result) => {
          this.events = result.data.filter(event => event.category_id === 2)
        }).catch(e => {
        })
      }
      api.campuses().then((result) => {
        this.campuses = result.data
      }).catch(e => {
      })
    },
    onNationalityChange() {
      this.selectedPace = null
      this.account.training_pace_id = null
      this.account.training_pace_name = null
    },
    trainingChoice(training) {
      this.trainingList = false
      this.account.training = training
      if (training.options.length > 0) {
        this.trainingOptions = training.options
      } else {
        this.trainingOptions = []
      }
    },
    optionChoice (option) {
      this.selectedOption = option.id
      this.account.training_option_id = option.id
      this.account.training_option_name = option.name
      this.account.training_pace_id = null
      this.account.training_pace_name = null
      if (option.pace_choice) {
        this.optionPaces = option.training_paces
      } else {
        this.optionPaces = []
      }
    },
    paceChoice(pace) {
      this.selectedPace = pace.id
      this.account.training_pace_id = pace.id
      this.account.training_pace_name = pace.name
    },
    campusChoice(campus) {
      this.campusList = false
      this.account.campus = campus
    },
    login() {
      if (
          this.$route.params.school === "france" ||
          this.$route.params.school === "suisse"
      ) {

        this.$router.replace({
          path:
              "/admissionsco/" + this.$route.params.school + "/connexion"
        });

      } else {
        this.$router.replace({
          path: "/admissionsup/" + this.$route.params.school + "/connexion"
        });
      }
    },
    updateCandidatePhone(phone) {
      if (this.account.phone && !phone.isValid) {
        this.errorMsg = "Attention votre numéro de téléphone ne semble pas valide"
      } else {
        this.errorMsg = null
      }
      this.account.phone_code = phone.countryCode
    },
    send() {
      this.$validator.validateAll().then((valid) => {

        if (valid) {
          this.toggleLoading()

          if (!this.isLoggedIn) {


            if (this.trainingSelected()) {
              this.account.school_slug = this.$route.params.school
              this.account.campus = this.account.campus.id
              services.docRegister(this.account).then((result) => {
                this.toggleLoading()

                if (result.status) {
                  switch (result.status) {
                    case 200:
                      this.userRegistered = true
                      this.existingEmail = false
                      this.$scrollTo('.jpo-form', {offset: -10}, 500)
                      break
                    case 422:
                      this.existingEmail = true
                      break
                    default:
                      if (this.account.training === null) {
                        this.errorMsg = 'Veuillez choisir la formation envisagée'
                      } else if (this.account.training.options.length && this.account.training_option_id === null) {
                        this.errorMsg = "Veuillez choisir l'option envisagée"
                      } else if (this.optionPaces.length && this.account.training_pace_id === null) {
                        this.errorMsg = 'Veuillez choisir un rythme'
                      } else if (this.account.campus === null) {
                        this.errorMsg = 'Veuillez choisir un campus'
                      } else {
                        this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
                      }

                  }
                }

                if (result.status_code) {
                  switch (result.status_code) {
                    case 200:
                      this.userRegistered = true
                      this.existingEmail = false
                      break
                    case 422:
                      this.existingEmail = true
                      break
                    default:
                      this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
                  }
                }

              }).catch(() => {
                this.toggleLoading()
              })
            } else {
              this.toggleLoading()
              if (this.account.training === null) {
                this.errorMsg = 'Veuillez choisir la formation envisagée'
              } else if (this.account.training.options.length && this.account.training_option_id === null) {
                this.errorMsg = "Veuillez choisir l'option envisagée"
              } else if (this.optionPaces.length && this.account.training_pace_id === null) {
                this.errorMsg = 'Veuillez choisir un rythme'
              } else if (this.account.campus === null) {
                this.errorMsg = 'Veuillez choisir un campus'
              }
            }

          } else {
            const event = {}
            event.candidate = this.candidate.id
            event.account = this.userAccount.id
            event.jpo = this.account.event
            apiCandidate.addJpoEvent(event).then(() => {
              this.toggleLoading()
              this.userRegistered = true
            }).catch((err) => {
              this.toggleLoading()
              this.error = err.message
            })
          }

        }

      })

    },
    trainingSelected () {
      if (this.account.training !== null) {
        if (this.trainingOptions.length > 0) {
          if (this.optionPaces.length > 0) {
            return this.account.training_option_id !== null
                && this.account.training_pace_id !== null
                && this.account.campus !== null
          }else{
            return this.account.training_option_id !== null
                && this.account.campus !== null
          }

        }else {
          return this.account.campus !== null
        }
      }
      return false;
    },
    getSchool () {
      api.showSchool(this.$route.params.school).then((result) => {
        const el = document.body;
        el.style.background = result.data.school_color
        el.style.padding = '1em'
        this.schoolColor = result.data.school_color
      }).catch(e => {

      })
    },
  },
  created() {
    const el = document.body;
    el.classList.add(this.slug);
    this.getSchool()
    this.fetchSchools()
    this.fetchCampuses()
    this.fetchSchoolTrainings()
    this.fetchSchoolEvents()
    this.refreshAccount()
  }
}
</script>
<style scoped>
.label {
  font-size: 1.6em;
  font-weight: 300;
}

.jpo-form {
  padding: 0 0;
}

</style>
<style lang="scss">


body {
  padding: 0.5em;
}

@media screen and (max-width: 768px) {
  body {
    padding: 0;
  }
}

.selected-option, .selected-section {
  background-color: #0f1e44;
  color: white;

  &:hover {
    background-color: #0f1e44;
    color: white;
  }
}

.content ul {
  list-style: disc outside;
  margin-left: 0em;
  margin-top: 1em;
}

.control.has-icons-left .icon, .control.has-icons-right .icon {
  z-index: 1;
}
.disabled-training-choice {
  opacity: 0.5;
  pointer-events: none;
}
</style>
